import React from 'react';

import Back from '../common/Back';
import Table from '../common/Table';
import pdfIcon from '../../images/pdf.svg';
import downloadIcon from '../../images/download.svg';

import style from './TrainingGuidesPage.module.css';

const TrainingGuidesPage = React.memo(() => {
  const columnSet = [
    {
      sortable: false,
      width: 45,
      Cell: () => <img src={pdfIcon} alt="pdf" />,
    },
    {
      accessor: 'guideName',
      Header: 'Training Guide name',
      sortable: true,
    },
    {
      sortable: false,
      width: 75,
      Cell: cell => (
        <a
          style={{
            backgroundImage: 'linear-gradient(180deg, #fff, #fff)',
            border: '1px solid #84829c',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 700,
            height: '45px',
            textAlign: 'center',
            padding: '5px 10px',
          }}
          className="btn"
          href={`${window.location.origin}/content/${cell.original.link}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View
        </a>
      ),
    },
    {
      sortable: false,
      width: 55,
      Cell: cell => (
        <a
          style={{
            backgroundImage: 'linear-gradient(180deg, #fff, #fff)',
            border: '1px solid #84829c',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 700,
            height: '45px',
            textAlign: 'center',
            padding: '0',
          }}
          className="btn"
          href={`${window.location.origin}/content/${cell.original.link}`}
          download
        >
          <img src={downloadIcon} alt="download" />
        </a>
      ),
    },
  ];

  const files = [
    {
      guideName: 'Functionality Overview',
      link: 'HUB-Training_Functionality-Overview.pdf',
    },
    { guideName: 'Forgot Password', link: 'HUB-Training_Forgot_password.pdf' },
    {
      guideName: 'Submit New Business Application',
      link: 'HUB-Training_Submit_New_Business_App.pdf',
    },
    {
      guideName: 'Finish Application',
      link: 'HUB-Training_Finish_Application.pdf',
    },
    {
      guideName: 'Review Application Results',
      link: 'HUB-Training_Review_Application_Results.pdf',
    },
    {
      guideName: 'Review Application with NO Quotes',
      link: 'HUB-Training_Review_Application_No_Quotes.pdf',
    },
    {
      guideName: 'Request Proposal Comparison',
      link: 'HUB-Training_Request_Proposal_Comparison.pdf',
    },
    { guideName: 'Request Bind', link: 'HUB-Training_Request_Bind.pdf' },
    {
      guideName: 'Review Policy Coverage Summary',
      link: 'HUB-Training_Review_Policy_Coverage_Summary.pdf',
    },
    {
      guideName: 'View Client Documents',
      link: 'HUB-Training_View_Client-Documents.pdf',
    },
    {
      guideName: 'Request Client Documents',
      link: 'HUB-Training_Request_Client_Documents.pdf',
    },
    {
      guideName: 'Request Cancel/ERP',
      link: 'HUB-Training_Request_Cancel_ERP.pdf',
    },
    {
      guideName: 'Request Endorsements',
      link: 'HUB-Training_Request_Endorsements.pdf',
    },
    {
      guideName: 'View Endorsement Requests',
      link: 'HUB-Training_View_Endorsement_Requestments.pdf',
    },
    { guideName: 'Add New User', link: 'HUB-Training_Add_New_User.pdf' },
    {
      guideName: 'Edit Existing User Profile',
      link: 'HUB-Training_Edit_User_Info.pdf',
    },
  ];

  return (
    <div className={style.trainingGuides}>
      <Back path="/tools" text="Reference Tools" />
      <h1>Training Guides</h1>
      <Table
        data={files}
        columns={columnSet}
        defaultPageSize={25}
        entityNameText="guides"
        pageSizeOptions={[5, 10, 25, 50, 10000]}
      />
    </div>
  );
});

TrainingGuidesPage.propTypes = {};

export default TrainingGuidesPage;
